import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BESTSELLERS_CATEGORY_URL_ID } from "@faire/retailer-shared/categories/urlId";
import { container } from "@faire/retailer-visitor-shared/components/PageNotFound/PageNotFoundTemplate.css";
import { ShopOurCategories } from "@faire/retailer-visitor-shared/components/ShopOurCategoriesV2";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import categoryRoute from "@faire/web-api--source/routes/category/c1CategoryUrlId";
import homePage from "@faire/web-api--source/routes/root";
import * as React from "react";
export var PageNotFoundTemplate = function(param) {
    var title = param.title, subtitle = param.subtitle, trackingContainerName = param.trackingContainerName;
    var isLoggedIn = useIsLoggedInRetailer();
    return /*#__PURE__*/ _jsxs(Column, {
        className: container,
        align: {
            mobileAndAbove: "flex-start",
            tabletAndAbove: "center"
        },
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: {
                    mobileAndAbove: "displaySSerifRegular",
                    tabletAndAbove: "displayMSerifRegular"
                },
                "data-test-id": "page-not-found-header",
                children: title
            }),
            subtitle ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: {
                            mobileAndAbove: "2x",
                            tabletAndAbove: "3x"
                        }
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "subheadingSansRegular",
                        "data-test-id": "page-not-found-text",
                        align: {
                            mobileAndAbove: "left",
                            tabletAndAbove: "center"
                        },
                        children: subtitle
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsx(Spacer, {
                height: {
                    mobileAndAbove: "2x",
                    tabletAndAbove: "3x"
                }
            }),
            isLoggedIn ? /*#__PURE__*/ _jsx(Button, {
                variant: "primary",
                linkTo: categoryRoute(BESTSELLERS_CATEGORY_URL_ID),
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "xXpU6S",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Shop bestsellers"
                        }
                    ]
                })
            }) : /*#__PURE__*/ _jsx(Button, {
                variant: "primary",
                linkTo: homePage({
                    signUp: "1"
                }),
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "ElITNn",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Sign up to shop"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: {
                    mobileAndAbove: "4x",
                    tabletAndAbove: "9x",
                    desktopAndAbove: "10x"
                }
            }),
            /*#__PURE__*/ _jsx(ShopOurCategories, {
                trackingContainerName: trackingContainerName
            })
        ]
    });
};
